import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";

type PrefetchAdjacentPagesProps = {
  pageNb: number | undefined;
  totalNbPages: number | undefined;
  sourceId: number;
  getQueryKey: (sourceId: number, pageNb: number) => any;
  //TODO: would be better if this wasn't any
  fetchSource: (sourceId: number, options: { page: number }) => Promise<any>;
};

const usePrefetchAdjacentPages = ({
  pageNb,
  totalNbPages,
  sourceId,
  getQueryKey,
  fetchSource,
}: PrefetchAdjacentPagesProps) => {
  const qc = useQueryClient();

  useEffect(() => {
    if (pageNb === undefined || totalNbPages === undefined) {
      return;
    }

    const prefetchPage = (pageNumber: number) => {
      const queryKey = getQueryKey(sourceId, pageNumber);
      console.log(`qk for prefetch page ${pageNumber}: ${queryKey}`);
      if (!qc.getQueryData(queryKey)) {
        console.log(`setting data for queryKey ${queryKey}`);
        qc.prefetchQuery(queryKey, () =>
          fetchSource(sourceId, { page: pageNumber })
        );
      }
    };

    if (pageNb > 1) {
      prefetchPage(pageNb - 1);
    }
    if (pageNb < totalNbPages) {
      prefetchPage(pageNb + 1);
    }
  }, [pageNb, totalNbPages, qc, sourceId, getQueryKey, fetchSource]);
};

export default usePrefetchAdjacentPages;
